import React from "react";
import { useTranslation } from "react-i18next";

function SuccessPopUp({ addOrEdit }) {
    const { t } = useTranslation("addProductsHeader");

    return (
        <div className="flex flex-col items-center gap-4 p-4">
            <img
                src="/product_added.svg"
                alt={t("alt")}
            />
            <p className="text-lg font-bold text-text-dark">
                {t("message", { action: addOrEdit })}
            </p>
        </div>
    );
}

export default SuccessPopUp;
